import { CardHeader, CardTitle, CardContent } from '@/components/Card'
import { Button } from '@/components/Button'

export interface InfoGatheringCardContentProps {
  title: string
  description: string
  isCompletionOpen: boolean
  canCompleteInfoGathering: boolean
  onComplete: () => unknown
}

export function InfoGatheringCardContent({
  title,
  description,
  isCompletionOpen,
  canCompleteInfoGathering,
  onComplete,
}: InfoGatheringCardContentProps) {
  return (
    <>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
      </CardHeader>
      <CardContent>{description}</CardContent>
      <CardContent compactBottomPadding={!isCompletionOpen}>
        {isCompletionOpen && (
          <Button
            label="Complete Info Gathering"
            variant="primary"
            size="wide-slim"
            testId="info-gathering-card-complete-button"
            onPress={onComplete}
            isDisabled={!canCompleteInfoGathering}
          />
        )}
      </CardContent>
    </>
  )
}
